import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';

// Prevent FA from auto-adding CSS — we import it above
config.autoAddCss = false;
